module.exports = __webpack_public_path__ + "04dcac210f3b4ba685a406d50f55a1c2.png";